import { ClerkProvider, useUser } from "@clerk/clerk-react";
import { useState } from "react";
import Landing from "./Landing";
import Paywall from "./Paywall";
import Dashboard from "./Dashboard";

const clerkKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// Add your email here to bypass paywall for testing
const ADMIN_EMAILS = ["pierrekr7@gmail.com"];

function AppContent() {
  const { isSignedIn, isLoaded, user } = useUser();
  const [subscribed, setSubscribed] = useState(() => {
    return localStorage.getItem("zeno_subscribed") === "true";
  });

  const handleSubscribed = () => {
    localStorage.setItem("zeno_subscribed", "true");
    setSubscribed(true);
  };

  if (!isLoaded) return (
    <div style={{ minHeight: "100vh", background: "#0a0a0f", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "monospace", color: "rgba(232,228,220,0.3)", letterSpacing: "0.2em", fontSize: 11 }}>
      LOADING...
    </div>
  );

  if (!isSignedIn) return <Landing />;

  // Bypass paywall for admin/test emails
  const userEmail = user?.emailAddresses?.[0]?.emailAddress;
  const isAdmin = ADMIN_EMAILS.includes(userEmail);

  if (!subscribed && !isAdmin) return <Paywall onSubscribed={handleSubscribed} />;
  return <Dashboard />;
}

export default function App() {
  return (
    <ClerkProvider publishableKey={clerkKey}>
      <AppContent />
    </ClerkProvider>
  );
}
